import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { CommonCard } from '../../common/card';
import styles from './thinkTime.module.scss';
import { Timer } from '../../common/timer';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';
import { shallow } from 'zustand/shallow';
import Button from '@components/common/button';

const cx = classNames.bind(styles);

export const ThinkTime = () => {
  const startThinking = useInterviewPracticeStore((state) => state.startThinking);
  const stopThinking = useInterviewPracticeStore((state) => state.stopThinking);
  const timer = useInterviewPracticeStore((state) => state.timer, shallow);
  const policies = useInterviewPracticeStore((state) => state.policies);
  const recorderService = useInterviewPracticeStore((state) => state.recorderService, shallow);
  const micScale = useInterviewPracticeStore((state) => state.micScale);
  const practiceQuestionInfo = useInterviewPracticeStore((state) => state.practiceQuestionInfo, shallow);
  const toNextStep = useInterviewPracticeStore((state) => state.practiceStepInfo.toNextStep, shallow);
  const currentPracticeIndex = useInterviewPracticeStore(
    (state) => state.practiceStepInfo.currentPracticeIndex,
    shallow,
  );

  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setEnabled(true);
      (async () => {
        await startThinking();
        toNextStep();
      })();
    }, 100);
  }, []);

  const handleClickEnd = () => {
    stopThinking();
    toNextStep();
  };

  const currentQuestion = practiceQuestionInfo.practiceQuestions[currentPracticeIndex];
  const movable = timer.increasingTime >= policies.minAnswerReadyTimeSec;

  return (
    <CommonCard className={cx('card', { enabled })}>
      <div>
        <div className={cx('question')}>
          <span className={cx('emphasis')}>Q{currentPracticeIndex + 1}.</span> {currentQuestion?.questionText}
        </div>

        <div className={cx('timerContainer')}>
          <Timer leftTime={timer.decreasingTime} title="답변 준비시간" totalTime={policies.maxAnswerReadyTimeSec} />
        </div>
      </div>

      <Button onClick={handleClickEnd} disabled={!movable} styles={{ width: 168, height: 48 }}>
        답변하기
      </Button>
    </CommonCard>
  );
};
